import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getNotificationInput,
  getNotificationsInput,
  NotificationBadgeModel,
  NotificationLiteModel,
  UnreadNotificationCountModel,
} from './model';

export function useGetNotificationByAcl(
  input?: getNotificationInput,
  options?: UseQueryOptions<
    ApiResult<{ [key: string]: NotificationBadgeModel }>,
    ApiError
  >,
): UseQueryResult<
  ApiResult<{ [key: string]: NotificationBadgeModel }>,
  ApiError
> {
  return useQuery(
    ['getNotificationByAcl', input?.acl],
    () =>
      QueryFetchFunction({
        url: `notification-badges/${input?.acl}`,
      }),
    options,
  );
}

export function useGetNotifications(
  input?: getNotificationsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<NotificationLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<NotificationLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getNotifications', input?.params],
      () => QueryFetchFunction({ url: 'notifications', params: input?.params }),
      options,
    ),
    NotificationLiteModel,
  );
}

export function useGetInfiniteNotifications(
  input?: getNotificationsInput,
  options?: UseInfiniteQueryOptions<
    ExtendedApiResult<NotificationLiteModel[]>,
    ApiError
  >,
): UseInfiniteQueryResult<
  ExtendedApiResult<NotificationLiteModel[]>,
  ApiError
> {
  return QueryTransformer(
    useInfiniteQuery<ExtendedApiResult<NotificationLiteModel[]>, ApiError>(
      ['getNotifications', input?.params],
      ({ pageParam = 1 }) =>
        QueryFetchFunction({
          url: 'notifications',
          params: { ...input?.params, page: pageParam },
        }),
      options,
    ),
    NotificationLiteModel,
  );
}

export function useGetUnreadNotificationsCount(
  options?: UseQueryOptions<
    ExtendedApiResult<UnreadNotificationCountModel>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<UnreadNotificationCountModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getUnreadNotificationsCount'],
      () => QueryFetchFunction({ url: 'notifications/unread-count' }),
      options,
    ),
    UnreadNotificationCountModel,
  );
}

export function getNotificationsKey(input?: getNotificationsInput) {
  return ['getNotifications', input?.params];
}

export function getUnreadNotificationsCountKey(input?: getNotificationsInput) {
  return ['getUnreadNotificationsCount'];
}
